import { useEffect } from 'react';

export default function Modal({ isOpen, onClose, title, children, className = '' }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      const handleEscape = (e) => {
        if (e.key === 'Escape') onClose();
      };
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('keydown', handleEscape);
        document.body.style.overflow = 'auto';
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        style={{
          backgroundColor: 'var(--color-bg-light)',
          borderRadius: 'var(--radius-xl)',
          maxWidth: '600px',
          maxHeight: '90vh',
          padding: 'var(--spacing-lg)',
          boxShadow: 'var(--shadow-lg)',
          overflow: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
        className={className}
      >
        {title && (
          <h2 id="modal-title" style={{ marginTop: 0 }}>
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
}
